import React, { useState, useEffect } from 'react'
import { Row, Col, Table, Button, Form, Modal } from "react-bootstrap";
import useStateRef from 'react-usestateref';
import { Link,json,useNavigate } from "react-router-dom";
import Card from "../../../../../components/Card";
import swal from 'sweetalert';
//import apiPath from "../../../../../config/apipath";
import apiService from "../../../../../provider/apiService";
import Select from 'react-select';
import "../../../../App.css";


const TableData = () => {

 const [SaveButtonText, setSaveButtonText] = useState("Save");

 useEffect(() => {
	
   if(sessionStorage.getItem("RepairTaggedScreen_Action")=="Add")
   {
	    setSaveButtonText("Save");
      
     
    setTagId("{Auto}");
    setTagNo("{Auto}");

	//Clear();
   
   }
   else if(sessionStorage.getItem("RepairTaggedScreen_Action")=="Edit")
   {
	   setSaveButtonText("Update");
	   Display(sessionStorage.getItem("RepairTaggedScreen_EditId"));
   }
   else if(sessionStorage.getItem("RepairTaggedScreen_Action")=="Delete")
   {
	   setSaveButtonText("Delete");
	   Display(sessionStorage.getItem("RepairTaggedScreen_EditId"));
   }
	
   ControlSettings();
   innitialSetValue();
   

  }, []);
  
  function innitialSetValue() {


  getLookup();
  
  GetGrnDetails1();
  }

 
   const [dtProd, setdtProd]=useState([]);
  const [dtSubProd, setdtSubProd]=useState([]);
  const [dtGrnDetails, setdtGrnDetails]=useState([]);
  const [dtGrnDetailsOrg, setdtGrnDetailsOrg]=useState([]);
  const [dtSize, setdtSize]=useState([]);
  const [dtTagType, setdtTagType]=useState([]);

 
   const [TMshow1, setTMShow1] = useState(false);
   const TMhandleClose1 = () => setTMShow1(false);
  



   const [LotNo, setLotNo, LotNoRef] = useStateRef(0);
   
   const [IssueNo, setIssueNo, IssueNoRef] = useStateRef(0);
   const [LotDate, setLotDate, LotDateRef] = useStateRef((new Date()).toISOString().substring(0,10));
   
   const [ProdName1, setProdName1, ProdName1Ref] = useStateRef('');
   const [GrossWt1, setGrossWt1, GrossWt1Ref] = useStateRef(0);
   const [GrossWtC1, setGrossWtC1, GrossWtC1Ref] = useStateRef(0);
   const [GrossWtP1, setGrossWtP1, GrossWtP1Ref] = useStateRef(0);
   const [Pcs1, setPcs1, Pcs1Ref] = useStateRef(0);
   const [PcsC1, setPcsC1, PcsC1Ref] = useStateRef(0);
   const [PcsP1, setPcsP1, PcsP1Ref] = useStateRef(0);
 

   const [TagId, setTagId, TagIdRef] = useStateRef(0);
   const [TagNo, setTagNo, TagNoRef] = useStateRef('');
   const [HUIDNo, setHUIDNo, HUIDNoRef] = useStateRef('');
   const [ProdCode, setProdCode, ProdCodeRef] = useStateRef(0);
   const [SubCode, setSubCode, SubCodeRef] = useStateRef(0);
   const [TagTypeId, setTagTypeId, TagTypeIdRef] = useStateRef(0);
   const [SizeCode, setSizeCode, SizeCodeRef] = useStateRef(0);
   
   const [Pcs, setPcs, PcsRef] = useStateRef(0);
   const [GrossWt, setGrossWt, GrossWtRef] = useStateRef(0);
   const [Touch, setTouch, TouchRef] = useStateRef(0);
   const [NetWt, setNetWt, NetWtRef] = useStateRef(0);
   const [Rate, setRate, RateRef] = useStateRef(0);
   const [LessWt, setLessWt, LessWtRef] = useStateRef(0);
   const [WasteP, setWasteP, WastePRef] = useStateRef(0);
   const [Waste, setWaste, WasteRef] = useStateRef(0);
   const [MCP, setMCP, MCPRef] = useStateRef(0);
   const [MC, setMC, MCRef] = useStateRef(0);
   const [HMCharges, setHMCharges, HMChargesRef] = useStateRef(0);
   const [OtherCharges, setOtherCharges, OtherChargesRef] = useStateRef(0);
   const [OrderNo, setOrderNo, OrderNoRef] = useStateRef(0);
   const [StoneAmt, setStoneAmt, StoneAmtRef] = useStateRef(0);
   const [StoneWtMode, setStoneWtMode, StoneWtModeRef] = useStateRef(0);
   const [id, setid, idRef] = useStateRef(0);
   const [MCGrm, setMCGrm, MCGrmRef] = useStateRef(0);
   
   const [LabelTxt, setLabelTxt, LabelTxtRef] = useStateRef('GRN No');
   const [SearchTxt, setSearchTxt, SearchTxtRef] = useStateRef('');

   const [StProdCode, setStProdCode, StProdCodeRef] = useStateRef(0);
   const [StSubCode, setStSubCode, StSubCodeRef] = useStateRef(0);
   const [StonePcs, setStonePcs, StonePcsRef] = useStateRef(0);
   const [StoneWt, setStoneWt, StoneWtRef] = useStateRef(0);
   const [StoneRate, setStoneRate, StoneRateRef] = useStateRef(0);
   const [StoneAmount, setStoneAmount, StoneAmountRef] = useStateRef(0);
   const [GoldRate, setGoldRate, GoldRateRef] = useStateRef(0);
   const [SilverRate, setSilverRate, SilverRateRef] = useStateRef(0);
   const [MetalCode, setMetalCode, MetalCodeRef] = useStateRef(0);
   const [WMode, setWMode, WModeRef] = useStateRef(0);
   const [PcsRate, setPcsRate, PcsRateRef] = useStateRef(0);
   const [ItemRate, setItemRate, ItemRateRef] = useStateRef(0);

   const [DtStDetTable, setDtStDetTable, DtStDetTableRef]=useStateRef([]);
   let StDetTable=[];
 





function SearchFun(text)
{
  setdtGrnDetails(dtGrnDetailsOrg.filter(function (x) {
    return x.LotNo.toLowerCase().indexOf(text.toLowerCase()) > -1;
}))
}  

 
  async function Clear()
   {
    
    setProdCode(0);
    setSubCode(0);
    setPcs(0);
    setGrossWt(0);
		setLessWt(0);
    setNetWt(0);
    setTagTypeId(0);
    setSizeCode(0);
    setRate(0);
    setTagId("{Auto}");
    setTagNo("{Auto}");
    setHMCharges("")
    setOrderNo("");
   
		
   }

function val(value)
{
	value=parseFloat(value);
	if(isNaN(value)==true)
		value=0;
	else
		value=value;
	
	return value;
}



async function Calc()
{
  
  setNetWt(val(GrossWtRef.current)-val(LessWtRef.current));

  if(val(NetWtRef.current)>val(GrossWtP1Ref.current))
  {
    let DiffWt=val(NetWtRef.current)-val(GrossWtP1Ref.current);
    swal({
      title: "",
      text: "The Weight Difference : " + DiffWt,
      icon: "info",
      button: "Ok"
    
    });
    
    setGrossWt(0);
    setLessWt(0);
    setNetWt(0);
    
    return;
  }









}


async function ControlSettings()
{

  document.getElementById("txtLotNo").disabled ='true';
  
  
  if((sessionStorage.getItem("RepairTaggedScreen_Action")=="Edit") || (sessionStorage.getItem("RepairTaggedScreen_Action")=="Delete"))
   {
  
   
   }
}



async function GetGrnDetails1()
{
  try
  {
   
    let postData = {
      "BranchCode":sessionStorage.getItem("BranchCode")
  }

  const results = await apiService.postCall("repairtaggedscreen/GetGrnDetails1",postData);

 if (results != "-1") {
   setdtGrnDetails(results.data[0]);
   setdtGrnDetailsOrg(results.data[0]);
 }

  
  }
  catch (error) {
    console.log(error);
  }
}


async function Display(EditId){
	  try
    {
     
      let postData = {
        EditId: EditId
    }

    const results = await apiService.postCall("repairtaggedscreen/Display",postData);


   if (results != "-1") {
     
	 let HeadData=results.data.Head;
 
   getLookup();

  
   setLotNo(HeadData[0][0].LotNo);
   setLotDate(HeadData[0][0].TagedDate.substring(0,10));
   setTagId(HeadData[0][0].TagId);
   setTagNo(HeadData[0][0].TagNo);
   

  
   setProdCode(HeadData[0][0].ProdCode);
   setSubCode(HeadData[0][0].SubCode);

   setTagTypeId(HeadData[0][0].infoCode);
   setSizeCode(HeadData[0][0].SizeCode);
   setPcs(HeadData[0][0].Pcs);
   setGrossWt(HeadData[0][0].GrossWt.toFixed(2));
   setRate(HeadData[0][0].Rate);
   setLessWt(HeadData[0][0].LessWt.toFixed(2));
   setNetWt(HeadData[0][0].NetWt.toFixed(2));
   setHMCharges(HeadData[0][0].HalMarkCharges);
   setOrderNo(HeadData[0][0].OrderNo);
   


   await setCheck(LotNoRef.current);

   await Calc();

   }

    
    }
    catch (error) {
      console.log(error);
    }

  }

  async function Err(msg)
  {
 
        swal({

          title: "",
          text: msg,
          icon: "info",
          button: "Ok"
          
        }).then(function () {
          
        });
  }


async function Save(){
	  try
		{
	
		// validation start
		
  
    if(LotNoRef.current=="0")
    {
      await Err("Please Select Lot No");
      return;
    }

    if(ProdCodeRef.current=="0")
    {
      await Err("Please Select Product");
      return;
    }

    if(SubCodeRef.current=="0")
    {
      await Err("Please Select Sub Product");
      return;
    }

    if(val(PcsRef.current)=="0")
    {
      await Err("Enter Pcs");
      return;
    }

    if(val(GrossWtRef.current)=="0")
    {
      await Err("Enter GrossWt");
      return;
    }

    

      // validation end


      

		 
		let postData = {
			"Action" : sessionStorage.getItem("RepairTaggedScreen_Action"),
			"EditId" : sessionStorage.getItem("RepairTaggedScreen_EditId"),
      "eBranchCode" : sessionStorage.getItem("BranchCode"),
			"FinMinDate": sessionStorage.getItem("FinMinDate"),
			"FinMaxDate": sessionStorage.getItem("FinMaxDate"),
			"EntryUser":sessionStorage.getItem("EntryUser"),
		  "LotNo":LotNoRef.current,
      "LotDate":LotDateRef.current,
      "ProdCode":ProdCodeRef.current,
      "SubCode":SubCodeRef.current,
      "InfoCode":TagTypeIdRef.current,
      "SizeCode":SizeCodeRef.current,
      "Pcs":PcsRef.current,
      "GrossWt":GrossWtRef.current,
      "LessWt":LessWtRef.current,
      "NetWt": NetWtRef.current,
      "HMCharges":HMChargesRef.current,
      "OrderNo":OrderNoRef.current,
      }
  
   const results = await apiService.postCall("repairtaggedscreen/Save",postData);

   if (results != "-1") {

if(results.errorCode=="8888")
{

  swal({

    title: "Alert",
    text: results.data,
    icon: "info",
    button: "Ok"
    
  }).then(function () {
    return;
  });

  return;

}  

  if(sessionStorage.getItem("RepairTaggedScreen_Action")=="Add")
   {
    swal({

      title: "Success",
      text: "Successfully Add Your Details!",
      icon: "success",
      button: "Ok"

    }).then(function () {
      setCheck(LotNoRef.current);
     Clear();
    });
	
  }

  else if(sessionStorage.getItem("RepairTaggedScreen_Action")=="Edit")
   {
    swal({

      title: "Success",
      text: "Successfully Update Your Details!",
      icon: "success",
      button: "Ok"

    }).then(function () {
      BackToList();
    });
	
  }
	 
  else if(sessionStorage.getItem("RepairTaggedScreen_Action")=="Delete")
  {
   swal({

     title: "Success",
     text: "Successfully Delete Your Details!",
     icon: "success",
     button: "Ok"

   }).then(function () {
     BackToList();
   });
 
 }
	 
      }
    }
    catch (error) {
      console.log(error);
    }

  }

  async function setCheck(id)
  {

    try
  {
   
    
  
    let postData = {
      "IssueNo": id,
      "Id": TagIdRef.current
  }

  const results = await apiService.postCall("repairtaggedscreen/GetGrnDetails",postData);

 if (results != "-1") {
  
  let data=results.data[0];

  

  setLotNo(data[0][0].LotNo);

  setProdName1(data[0][0].ProdName);
  setGrossWt1(data[0][0].Grosswt.toFixed(2));
  setGrossWtC1(data[0][0].TagedWt.toFixed(2));
  setGrossWtP1(data[0][0].BWt.toFixed(2));
  setPcs1(data[0][0].Pcs);
  setPcsC1(data[0][0].TagedPcs);
  setPcsP1(data[0][0].BPcs);

  setOrderNo(results.data[3]);
  
 
 }

 setTMShow1(false);

  
  }
  catch (error) {
    console.log(error);
  }

   


}






  async function getsubProd(){
    try {
     
     let postData = {
      "ProdCode" : ProdCodeRef.current
     };
     
  
    const results = await apiService.postCall("repairtaggedscreen/getsubProd",postData);
 
    if (results != "-1") {
      setdtSubProd(results.data[0][0]);
      setdtSize(results.data[1][0]);
     }
} catch (error) {
       console.log(error);
     }
 }
    
  async function getLookup(){
	 try {		
				 

		let postData = {
      "ProdCode" : ProdCodeRef.current,
      "LotDate": LotDateRef.current,
      "Action" :sessionStorage.getItem("RepairTaggedScreen_Action")
    };
		

   
    const results = await apiService.postCall("repairtaggedscreen/Lookup",postData);

	 if (results != "-1") {



    if(results.errorCode=="8888")
{

  swal({

    title: "Alert",
    text: results.data,
    icon: "info",
    button: "Ok"
    
  }).then(function () {
    return;
  });

  return;

}  
    setdtProd(results.data[0][0]);
    setdtSubProd(results.data[1][0]);
    setdtTagType(results.data[2][0]);
    setdtSize(results.data[3][0]);


      }

    } catch (error) {
      console.log(error);
    }
}

 
  const navigate = useNavigate();
  const BackToList = () => {
    navigate('../dashboard/table/plussing/repairtaggedscreen/list');
  };

  return (
    <>
    

      <Row className="">
        <Card>
          <Card.Header className="d-flex justify-content-between">
            <div className="header-title">
              <h4 className="card-title">Repair Tagged Entry Screen</h4>
            </div>
          </Card.Header>
          <Card.Body>
            <div className='container'>
              <div className='container-fluid'>
                <div className='row'>
                  <div className='col-lg-12' id="div100">
                    <div className='col-md-12 col-lg-12 col-sm-12 col-xs-12'>
                      <div className='container-fluid py-4 '>
                        <div className='row py-4'>

                        <div className='col-md-2'>
                            <Form.Label><a onClick = {(e) => {
                              if(sessionStorage.getItem("RepairTaggedScreen_Action")=="Add")
                             { setTMShow1(true)}

                              }} href="#">Lot No</a></Form.Label>
                            <Form.Control type="text" Readonly="Readonly" disabled="disabled" id="txtLotNo" placeholder="" value={LotNo}  />
                          </div>
                         
                          <div className='col-md-3'>
                            <Form.Label>Date</Form.Label>
                            <Form.Control type="date" Readonly="Readonly" disabled="disabled" id="txtLotDate" placeholder="" value={LotDate} onChange={(e)=>setLotDate(e.target.value)} />
                          </div>

                          <div className='col-md-7'>
                            <Form.Label>Product Name</Form.Label>
                            <Form.Control type="text" Readonly="Readonly" disabled="disabled" id="txtProdName1" placeholder="" value={ProdName1} onChange={(e)=>setProdName1(e.target.value)} />
                          </div>

                          <div className='col-md-4'>
                            <Form.Label>Gross Wt</Form.Label>
                            <Form.Control type="text" Readonly="Readonly" disabled="disabled" id="txtGrossWt1" placeholder="" value={GrossWt1} onChange={(e)=>setGrossWt1(e.target.value)} />
                          </div>

                          <div className='col-md-4'>
                            <Form.Label>Completed</Form.Label>
                            <Form.Control type="text" Readonly="Readonly" disabled="disabled" id="txtGrossWtC1" placeholder="" value={GrossWtC1} onChange={(e)=>setGrossWtC1(e.target.value)} />
                          </div>


                          <div className='col-md-4'>
                            <Form.Label>Pending</Form.Label>
                            <Form.Control type="text" Readonly="Readonly" disabled="disabled" id="txtGrossWtP1" placeholder="" value={GrossWtP1} onChange={(e)=>setGrossWtP1(e.target.value)} />
                          </div>



                          <div className='col-md-4'>
                            <Form.Label>Pcs</Form.Label>
                            <Form.Control type="text" Readonly="Readonly" disabled="disabled" id="txtPcs1" placeholder="" value={Pcs1} onChange={(e)=>setPcs1(e.target.value)} />
                          </div>

                          <div className='col-md-4'>
                            <Form.Label>Completed</Form.Label>
                            <Form.Control type="text" Readonly="Readonly" disabled="disabled" id="txtPcsC1" placeholder="" value={PcsC1} onChange={(e)=>setPcsC1(e.target.value)} />
                          </div>


                          <div className='col-md-4'>
                            <Form.Label>Pending</Form.Label>
                            <Form.Control type="text" Readonly="Readonly" disabled="disabled" id="txtPcsP1" placeholder="" value={PcsP1} onChange={(e)=>setPcsP1(e.target.value)} />
                          </div>

    
   </div>
	  </div>
</div>

</div>


                  </div>
                 


                  <div className='row'>
                  <div className='col-lg-6'>
                    <div className='col-md-12 col-lg-12 col-sm-12 col-xs-12'>
                      <div className='container-fluid py-4 '>
                        <div className='row py-4'>

                          <div className='col-md-12'>
                            <Form.Label>Product</Form.Label>
                            <Select className="form-select-search" isSearchable={true} onBlur={Calc}
                                          value={dtProd.filter(function(option) {
                                             return option.value === ProdCode;
                                           })}
                                          options={dtProd}
                                          id="txtProd"  
                                          onChange=
                                          {
                                             (e) => {
                                              setProdCode(e.value)
                                              getsubProd()   
                                             }
                                             } >

                            </Select>
                          </div>


                          <div className='col-md-12'>
                            <Form.Label>Sub Product</Form.Label>
                            <Select className="form-select-search" isSearchable={true} onBlur={Calc}
                                          value={dtSubProd.filter(function(option) {
                                             return option.value === SubCode;
                                           })}
                                          options={dtSubProd}
                                          id="txtSubProd"  
                                          onChange=
                                          {
                                             (e) => {
                                              setSubCode(e.value)
                                             }
                                             } >

                            </Select>
                          </div>


                          <div className='col-md-6'>
                            <Form.Label>Tag Type</Form.Label>
                            <Select className="form-select-search" isSearchable={true} onBlur={Calc}
                                          value={dtTagType.filter(function(option) {
                                             return option.value === TagTypeId;
                                           })}
                                          options={dtTagType}
                                          id="txtTagType"  
                                          onChange=
                                          {
                                             (e) => {
                                              setTagTypeId(e.value)
                                             }
                                             }>

                            </Select>
                          </div>



                        
                          <div className='col-md-6'>
                            <Form.Label>Size</Form.Label>
                            <Select className="form-select-search" isSearchable={true} 
                                          value={dtSize.filter(function(option) {
                                             return option.value === SizeCode;
                                           })}
                                          options={dtSize}
                                          id="txtSize"  
                                          onChange=
                                          {
                                             (e) => {
                                              setSizeCode(e.value)
                                             }
                                             }>

                            </Select>
                          </div>

   </div>
	  </div>
</div>

</div>


  <div className='col-lg-6'>
                    <div className='col-md-12 col-lg-12 col-sm-12 col-xs-12'>
                      <div className='container-fluid py-4 '>
                        <div className='row py-4'>
                        <div className='col-md-4'>
                            <Form.Label>Tag Id</Form.Label>
                            <Form.Control type="text" Readonly="Readonly" disabled="disabled" id="txtTagId" placeholder="" value={TagId} onChange={(e)=>setTagId(e.target.value)} />
                          </div>
                       
                          <div className='col-md-4'>
                            <Form.Label>Tag No</Form.Label>
                            <Form.Control type="text" Readonly="Readonly" disabled="disabled" id="txtTagNo" placeholder="" value={TagNo} onChange={(e)=>setTagNo(e.target.value)} />
                          </div>

                        

                          <div className='col-md-4'>
                            <Form.Label>Pcs</Form.Label>
                            <Form.Control type="text"  id="txtPcs" placeholder="" value={Pcs} onChange={(e)=>setPcs(e.target.value)} />
                          </div>

                          <div className='col-md-4'>
                            <Form.Label>Gross Wt</Form.Label>
                            <Form.Control type="text" id="txtGrossWt" placeholder="" value={GrossWt} 
                            onChange={(e)=>{setGrossWt(e.target.value)
                            }
                          } onBlur={Calc} />
                          </div>

                       

                          <div className='col-md-4'>
                            <Form.Label>Less Wt</Form.Label>
                            <Form.Control type="text"   id="txtLessWt" placeholder="" value={LessWt} onChange={(e)=>{
                              setLessWt(e.target.value)
                              }} onBlur={Calc} />
                          </div>

                          <div className='col-md-4'>
                            <Form.Label>Net Wt</Form.Label>
                            <Form.Control type="text"  Readonly="Readonly" disabled="disabled" id="txtNetWt" placeholder="" value={NetWt} onChange={(e)=>setNetWt(e.target.value)} />
                          </div>

                          <div className='col-md-4'>
                            <Form.Label>Order No</Form.Label>
                            <Form.Control type="text"   id="txtOrderNo" placeholder="" value={OrderNo} onChange={(e)=>setOrderNo(e.target.value)} />
                          </div>


   </div>
	  </div>
</div>
    
</div>


</div>
                  
              </div>
             

                 
               
           
			  	
				
			    
				
				<Modal show={TMshow1} onHide={TMhandleClose1} className=".modal-lg"  id ="otherlotentrytableModal" >
                  <Modal.Header closeButton>
                    <Form.Control type="text" placeholder='Search' value={SearchTxt} onChange={(e)=> { 
                      setSearchTxt(e.target.value)
                      SearchFun(e.target.value)
                      }}/>
                  </Modal.Header>

                  <Modal.Body>
                    
                                 
              <div className="table-responsive mt-4" id="otherlotentrytable1" >
			 
				
       <Table striped id="table-basic" className="table-striped mb-0" role="grid">
         <thead>
           <tr>
           <th>Lot No</th>
             <th>Prod Name</th>
             <th>Item Name</th>   
             <th>GRN No</th>              
             <th>Pcs</th>              
             <th>Weight</th>          
             
           </tr>
         </thead>
         <tbody>
         {dtGrnDetails.map((item) => (
           <tr>
            
            <td>  
    
    <Form.Check className="me-2">
                              
                              <Form.Check.Input type="radio" name="g1" onChange={(e) => setCheck(item.LotNo)} checked={item.checked} className="lstItems" id={item.LotNo} />
                              
                              <Form.Check.Label>{item.LotNo}</Form.Check.Label>
                            </Form.Check>
                            </td>
        
            
            <td>{item.ProdName}</td>
            <td>{item.SubProduct}</td>
            <td>{item.GrnNo}</td>
            <td>{item.BPcs}</td>
            <td>{item.BWt.toFixed(2)}</td>
           



           </tr>
             )
             )
              }     
         </tbody> 
       </Table>
      
     </div>

					 </Modal.Body>
                 </Modal>
				
	
          
              <div className='pt-2' style={{ direction: 'rtl' }} >
                <Form.Group className="form-group">
                  <Button type="button" variant='btn btn-primary' >
                    <i className="btn-inner">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-printer" viewBox="0 0 16 16">
                        <path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z" />
                        <path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2H5zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4V3zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2H5zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1z" />
                      </svg>
                    </i>
                    <span>Print</span>
                  </Button>{' '}
                  <Button type="button" variant="btn btn-danger" onClick={BackToList}>cancel</Button> {' '}
                  <Button type="button" variant="btn btn-primary" onClick={Save}>{SaveButtonText}</Button>
                </Form.Group>
              </div>
            </div>
          </Card.Body>
        </Card>
      </Row >
    </>
  );
};

export default TableData;
